export default [
  {
    title: 'Sales',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Price List',
        route: 'price-list',
      },
      {
        title: 'Sales Order Type',
        route: 'sales-order-type',
      },
      {
        title: 'Station Type',
        route: 'station-type',
      },
      {
        title: 'Sales Order',
        route: 'sales-order',
      },
      {
        title: 'Sales Invoice',
        route: 'sales-invoice',
      },
      {
        title: 'Sales Return',
        route: 'sales-return',
      },
      {
        title: 'Ibico Invoice',
        route: 'ibico-invoice-list',
      },
      {},
    ],
  },
];
